<section class="info-container">
    <div class="card">
        <div class="card-body">
            <h1 class="card-title h5">SWIPE & WIN</h1>
            <div>
                <h6 class="font-weight-bold">HOW TO PLAY: </h6>
                <ul class="text-black-50 pl-3">
                    <li>Subscribe to Swipe & Win, Play the game and claim the prizes.</li>
                    <li>Answer questions by swiping photos left.</li>
                    <li>You have 45 seconds to answer as many questions as possible</li>
                    <li>Be careful! For each wrong answer you lose 5 seconds</li>
                    <li>What to improve your score?
                        Buy additional game </li>
                </ul>
            </div>
        </div>
    </div>
</section>